<template>
  <q-tab-pane name="quotes" class="scroll-y" :class="{ 'no-padding': quotes.length !== 0 }">
    <!-- Wrapping div to fix safari sticky position -->
    <div>
      <div v-if="quotes.length && !isSupplier" class="row sticky-top bg-white q-px-md q-py-sm border-bottom customer-card__toolbar" v-is-user>
        <q-btn flat icon="add" :label="$tc('quote', 1)" @click="handleCreateQuote"></q-btn>
      </div>

      <div class="text-select">
        <quote-table
          v-if="quotes.length"
          :quotes="quotes"
          :mapFunctionOverride="mapFunction"
          :columnsOverride="columns"
          class="no-shadow"
        />
        <template v-else>
          <div class="row justify-center items-center col-grow q-pt-lg">
            <div class="text-center">
              <img src="~assets/emptystates/invoices_empty.svg" height="100px"/>

              <h6 class="q-my-md text-faded">{{ $t('quotes_empty') }}</h6>

              <q-btn v-if="!isSupplier" @click="handleCreateQuote" color="primary" class="q-mt-lg" outline v-is-user>
                {{ $t('create_quote') }}
              </q-btn>
            </div>
          </div>
        </template>
      </div>
    </div>
  </q-tab-pane>
</template>

<script>
  import { columns, mapFunction } from 'components/Quotes/Table/customerQuoteTable'
  import QuoteTable from 'components/Quotes/Table/StaticQuoteTable.vue'
  import { businessPartnerTypes } from 'src/utils/businessPartnerTypes'

  export default {
    props: {
      customer: {
        type: Object,
        required: true
      }
    },

    computed: {
      quotes () {
        return this.customer.quotes ? this.customer.quotes.data : []
      },

      mapFunction () {
        return mapFunction
      },

      columns () {
        return columns
      },

      isSupplier () {
        return this.customer.business_partner_type === businessPartnerTypes.SUPPLIER
      }
    },

    methods: {
      handleCreateQuote () {
        this.$router.push({
          name: 'create-quote',
          params: { teamId: this.customer.team_id },
          query: { customer: this.customer.id }
        })
      }
    },

    components: {
      QuoteTable
    }
  }
</script>
